import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Building2, Heart, Network } from 'lucide-react';

const audiences = [
  {
    icon: Building2,
    title: 'Independent Rural Clinics',
    desc: 'You own the practice. Every dollar of unclaimed revenue hurts. VitalsFlow recovers it automatically.',
  },
  {
    icon: Heart,
    title: 'Federally Qualified Health Centers (FQHCs)',
    desc: 'You serve the underserved. VitalsFlow is designed with Section 330 compliance in mind — built to support the workflows FQHCs depend on.',
  },
  {
    icon: Network,
    title: 'Rural Health Networks',
    desc: 'You manage multiple sites. VitalsFlow deploys across all of them with one group license and zero hardware.',
  },
];

export default function WhoItsFor() {
  const [ref, isVisible] = useScrollAnimation(0.1);

  return (
    <section id="audience" data-testid="audience-section" className="py-24 md:py-32 px-4 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`scroll-fade-up ${isVisible ? 'visible' : ''}`}>
          <p className="uppercase text-xs tracking-[0.2em] text-vf-forest font-body font-semibold mb-4 text-center">
            Who It's For
          </p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-vf-charcoal tracking-tight mb-4 text-center leading-tight">
            Built for the Backbone of America.
          </h2>
          <p className="font-body text-base md:text-lg text-vf-charcoal/60 text-center max-w-2xl mx-auto mb-16">
            While big tech builds for city hospitals, we are building for the 13,000+ Rural Health Clinics
            that keep our country running. We navigate the complex federal grant cycles so you don't have to.
          </p>
        </div>

        <div className={`stagger-children ${isVisible ? 'visible' : ''} grid grid-cols-1 md:grid-cols-3 gap-6`}>
          {audiences.map((aud) => (
            <div
              key={aud.title}
              data-testid="audience-card"
              className="bg-vf-salt border border-vf-sage p-8 md:p-10 hover:-translate-y-1 hover:shadow-sm transition-all duration-300 group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-vf-forest mb-6">
                <aud.icon size={28} strokeWidth={1.5} className="text-vf-mint" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-vf-charcoal mb-3">
                {aud.title}
              </h3>
              <p className="font-body text-sm text-vf-charcoal/60 leading-relaxed">
                {aud.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
